/* eslint-disable import/no-anonymous-default-export */


export default {
    baseurl: `https://oxygenapi.dev-hi.xyz/api`,
}